<template>
    <modal
        name="disable-sync-employee-modal"
        class="modal--translation"
        v-cloak height="auto"
        :scrollable="false"
        :adaptive="false"
        :pivot-y="0.25"
    ><!-- todo $refs-->

        <div :class="{'loading': loading }">
            <div class="modal-header">
                <button @click="closeModal()" type="button" class="close close-modal mr-2"><i class="fal fa-fw fa-times"></i></button>
                <h5 class="modal-title mb-0"><i class="fa fa-exclamation-triangle mr-3"></i>{{ trans.modal_title }}</h5>
            </div>

            <div class="modal-body p-0" :class="{'loading': loading }">
                <div class="row">
                    <div class="col-md-12">
                        <p>{{ trans.modal_body }}</p>
                        <dl>
                          <dt class="text-muted font-weight-normal">{{ trans.employee }}:</dt>   <dd><b>{{ employee.full_name }}</b></dd>
                          <dt class="text-muted font-weight-normal">{{ trans.email }}:</dt>      <dd><b>{{ employee.email }}</b></dd>
                        </dl>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-md-12">
                        <form>
                            <div class="form-group">
                                <input class="form-check-input" type="checkbox" :id="'disable_delete_confirmation_' + this.employee.id" v-model="checked" :value="checked">
                                <label class="form-check-label font-sm" :for="'disable_delete_confirmation_' + this.employee.id">{{ trans.checkbox_title }}</label>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="modal-footer text-center">
                <b-button
                        type="button"
                        variant="danger"
                        @click="submitForm()"
                        :class="{'disabled': loading }"
                >
                    <i :class="this.loading ? 'fal fa-fw mr-1 fa-spin fa-spinner' : 'fal fa-check mr-2'"></i>{{ trans.yes }}
                </b-button>
                <b-button
                        type="button"
                        variant="light"
                        @click="closeModal()"
                        :class="{'disabled': loading }"
                >
                    {{ trans.no }}
                </b-button>
            </div>
        </div>
    </modal>
</template>


<script>
export default {
    props: {
        'baseUrl': {
            type: String
        },
        'trans': {
            type: Object
        },
        'employee': {
            type: Object
        }
    },

    data: function() {
        return {
            loading: false,
            checked: true,
        };
    },

    methods: {
        submitForm() {
            this.loading = true;

            axios.delete(this.baseUrl, {data: { employeeId: this.employee.id, deletable: this.checked }})
                .then(success => {
                    this.closeModal();
                    this.$notify({ type: 'success', title: this.trans.request_api_success });
                    this.loading = false;
                    this.$emit('submit-form-success', false);
                })
                .catch(error => {
                    this.closeModal();
                    this.$notify({ type: 'error', title: this.trans.request_api_error });
                    this.loading = false;
                });
        },

        closeModal() {
            this.$modal.hide('disable-sync-employee-modal');
        },
    },
};
</script>

<style lang="scss" scoped>
    .modal-header {
        padding: 0;
        margin: 0 0 35px;
        border-bottom: 0;
    }
    h6.head-title {
        margin-bottom: 20px;
        font-size: 1.1rem;
    }
    .modal-footer {
        padding: 0;
        margin-top: 18px;
        border: 0;
    }
    .form-group {
        margin-bottom: 3px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/employee/modals/DisableSyncEmployeeModal.vue